"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEmptyStateMap = void 0;
const react_1 = require("react");
const getEmptyStateMap = (columns) => {
    const obj = {};
    columns.forEach((column) => {
        if (!('type' in column)) {
            obj[column.id] = column.defaultValue;
        }
    });
    return obj;
};
exports.getEmptyStateMap = getEmptyStateMap;
const useStateMap = (columns) => {
    const [stateMap, setStateMap] = (0, react_1.useState)((0, exports.getEmptyStateMap)(columns));
    return [stateMap, setStateMap];
};
exports.default = useStateMap;
//# sourceMappingURL=useStateMap.js.map